export default "__VITE_ASSET__DnUuvmEa__"